import axios from "axios";
import CONFIG from "../model/TSConfig";
import type ManagedAccount from "@tootsweet/model/entities/ManagedAccount";

export interface CreateNewVenueRequest {
  placeName?: string;
  planId?: string;
  commitment?: string;
  copyFromAccountId?: string;
  useSamePaymentMethod?: boolean;
}

export async function createNewVenue(
  request: CreateNewVenueRequest,
  token: string
): Promise<ManagedAccount> {
  const response = await axios.post<ManagedAccount>(
    `${CONFIG.saasBackendUrl}/customers/new`,
    request,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );

  return response.data;
}
